import * as yup from 'yup';

export const healthCheckSchema = yup.object().shape({
  firstName: yup.string().required('Please enter your first name.'),
  lastName: yup.string().required('Please enter your last name.'),
  email: yup
    .string()
    .email('Please enter a valid email address.')
    .required('Please enter your email address.'),
  phone: yup.string().required('Please enter your number.'),
  country: yup.string().required('Please enter your country.'),
  australianTaxFileNumber: yup
    .string()
    .required('Please enter tax file number.'),
  dateOfBirth: yup.string().required('Please select date of birth.'),
  agreeToTerms: yup.boolean().required('Please agree to the terms.'),
  taxIncomeType: yup
    .array()
    .of(yup.string())
    .required('Please select at least one income type'),
  propertyIds: yup.array().of(yup.mixed()),
  mortgageReviewRequest: yup.boolean().required('Please select any option.'),
});
